import * as React from 'react';
import * as style from './style.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SkeletonHeader = function SkeletonHeader() {
  return /*#__PURE__*/_jsxs("div", {
    className: style['header'],
    children: [/*#__PURE__*/_jsx("div", {
      className: style['image']
    }), /*#__PURE__*/_jsxs("div", {
      className: style['info-block'],
      children: [/*#__PURE__*/_jsxs("div", {
        className: style['layout'],
        children: [/*#__PURE__*/_jsxs("div", {
          className: style['layout-params'],
          children: [/*#__PURE__*/_jsx("div", {
            className: style['layout-title']
          }), /*#__PURE__*/_jsx("div", {
            className: style['layout-square']
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: style['layout-price'],
          children: [/*#__PURE__*/_jsx("div", {
            className: style['price']
          }), /*#__PURE__*/_jsx("div", {
            className: style['price-per-meter']
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: style['contacts'],
        children: [/*#__PURE__*/_jsxs("div", {
          className: style['contacts-contact'],
          children: [/*#__PURE__*/_jsx("div", {
            className: style['contact-image']
          }), /*#__PURE__*/_jsxs("div", {
            className: style['contacts-contact-title'],
            children: [/*#__PURE__*/_jsx("div", {
              className: style['contact-title-type']
            }), /*#__PURE__*/_jsx("div", {
              className: style['contact-title-name']
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: style['contacts-control']
        })]
      })]
    })]
  });
};